import BpkImage, {
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner-internal/backpack-web/bpk-component-image';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classNames from 'classnames';

import { useMBDContext } from '../common/MBD/useMBDContext';

import type { IndexBlockPanelProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/IndexBlockPanel';

import STYLES from './IndexBlockPanel.module.scss';

const documentIfExists = typeof window !== 'undefined' ? document : null;
const LazyLoadedImage = withLoadingBehavior(
  withLazyLoading(BpkImage, documentIfExists),
);

const IndexBlockPanel = ({
  dataList,
  desc,
  fullWidth,
  isMobile,
  title,
}: IndexBlockPanelProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  return (
    <div
      className={classNames(STYLES.IndexBlockPanel, {
        [STYLES['IndexBlockPanel--full-width']]: fullWidth,
      })}
      data-testid="indexBlockPanel"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <div
        className={classNames(STYLES.IndexBlockPanel__container, {
          [STYLES['IndexBlockPanel__container--full-width']]: fullWidth,
        })}
      >
        {title && (
          <BpkText
            tagName="h2"
            textStyle={isMobile ? TEXT_STYLES.heading3 : TEXT_STYLES.heading2}
            className={STYLES.IndexBlockPanel__title}
          >
            {title}
          </BpkText>
        )}
        {desc && (
          <BpkText
            tagName="p"
            className={STYLES.IndexBlockPanel__desc}
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        )}
        <div className={STYLES.IndexBlockPanel__itemList}>
          {dataList.map((item) => (
            <article key={item.title} className={STYLES.IndexBlockPanel__item}>
              <div className={STYLES.IndexBlockPanel__imgBox}>
                <LazyLoadedImage altText="" aspectRatio={1} src={item.img} />
              </div>
              <div className={STYLES.IndexBlockPanel__itemHead}>
                <BpkText
                  tagName="h3"
                  textStyle={
                    isMobile ? TEXT_STYLES.heading4 : TEXT_STYLES.heading3
                  }
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
              </div>
              <div className={STYLES.IndexBlockPanel__itemBody}>
                <BpkText
                  tagName="p"
                  textStyle={TEXT_STYLES.bodyDefault}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IndexBlockPanel;
